import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const IconPaperClip = styled.span`
  position: relative;
  color: ${COLOR.GUNSMOKE};
  font-size: 18px;
  top: 3px;
  margin-left: 0;
  margin-right: 7px;
`;

export const Bold = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`;
